module.exports = __webpack_public_path__ + "static/media/v.0601b319.jpg";